import React from 'react';
import { SMenuItemGroupTopBar, SMenuItemListbox, SMenuItemroupContainer } from './MenuItemGroup.styled';
import Text from '../text/Text.styled';

interface IProps {
  children: React.ReactNode;
  title: string;
}

const MenuItemGroup: React.FC<IProps> = ({ children, title }) => {
  return (
    <SMenuItemroupContainer>
      <SMenuItemGroupTopBar>
        <Text color="white" size="xs">
          {title}
        </Text>
      </SMenuItemGroupTopBar>
      <SMenuItemListbox>{children}</SMenuItemListbox>
    </SMenuItemroupContainer>
  );
};

export default MenuItemGroup;
